import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { F as FirstPageIcon } from './icons/FirstPageIcon-7edd7d47.js';
import { P as PaginationButton } from './PaginationButton-bd91a79f.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-39f30e88.js';

const PaginationFirstButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-first-button')
}, props), /*#__PURE__*/React__default.createElement(FirstPageIcon, null));
PaginationFirstButton.displayName = 'PaginationFirstButton';
var PaginationFirstButton$1 = PaginationFirstButton;

export { PaginationFirstButton$1 as P };
//# sourceMappingURL=PaginationFirstButton-ef711640.js.map
